import { formatPersonName } from '@gb-ticket/shared-types';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { usePageTitle } from '@/hooks/use-page-title';
import { formatDateTime } from '@/lib/format';
import { PlatformPageHeader } from '@/platform/components/platform-page-header';
import { useProfileEdit } from '@/platform/features/profile/profile-edit-context';
import { ProfilePageShell, ReadOnly } from '@/platform/features/profile/profile-shared';
import { USER_JOB_TITLE_LABEL } from '@/platform/features/users/user-labels';
import { useVoice } from '@/platform/voice/use-voice';

function choiceLabel(name: string | null, active: boolean): string {
  const text = name?.trim() ?? '';
  if (!text) {
    return '—';
  }
  return active ? text : `${text} (inaktiv)`;
}

export function ProfileAccountPage() {
  usePageTitle('Kontodaten · Profil');
  const { profile } = useProfileEdit();
  const voice = useVoice();

  return (
    <ProfilePageShell>
      <PlatformPageHeader
        title="Kontodaten"
        description="Name und E-Mail pflegt die IT im Verzeichnis."
      />

      <Card>
        <CardHeader>
          <CardTitle>Konto</CardTitle>
          <CardDescription>Name und E-Mail pflegt die IT im Verzeichnis.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Name und E-Mail-Adresse werden von der IT im Verzeichnis gepflegt und können hier nicht
            geändert werden.
          </p>
          <div className="grid gap-3 text-sm sm:grid-cols-2">
            <ReadOnly label="E-Mail" value={profile.email} />
            <ReadOnly label="Name" value={formatPersonName(profile, voice)} />
            <ReadOnly label={USER_JOB_TITLE_LABEL} value={profile.jobTitle ?? '—'} />
            <ReadOnly
              label="Abteilung"
              value={choiceLabel(profile.departmentName, profile.departmentActive)}
            />
            <ReadOnly label="Standort" value={choiceLabel(profile.siteName, profile.siteActive)} />
            <ReadOnly label="Letzte Anmeldung" value={formatDateTime(profile.lastLoginAt)} />
          </div>
          <details className="rounded-md border px-3 py-2 text-sm">
            <summary className="cursor-pointer font-medium">Technische Angaben</summary>
            <div className="mt-3 grid gap-3 sm:grid-cols-2">
              <ReadOnly label="Entra-Kennung" value={profile.entraObjectId ?? '—'} />
            </div>
          </details>
        </CardContent>
      </Card>
    </ProfilePageShell>
  );
}
